import React, { useContext, useState, Fragment, useEffect } from "react";
import '../../../ui-styles/list/ListAutoUnderLine.css';
import "../../../ui-styles/animations/ripple.css";
import { LangCtx } from "../../../lib/context";
import BtmEditDeletSlider from '../../../lib/ui/BtmEditDeletSlider';
import BtmDeleteSlide from '../../../lib/ui/BtmDeleteSlider';
import { deleteSolt } from "../../../actions/schedule";
import CreateSlot from "./CreateSlot";

const SlotListItem = (props) => {
    const { l } = useContext(LangCtx);
    const [slideED, setSlideED] = useState(false);
    const [isDelete, setDelete] = useState(false);
    const [edit, setEdit] = useState(false);
    const [data, setData] = useState({});

    useEffect(() => {
        if (props.slotData) {
            setData(props.slotData);
        }
    }, [props.slotData]);

    const getTime = (d) => {
        let now = new Date(d);
        // now.setHours(d / 60);
        // now.setMinutes(d % 60);
        return now.toLocaleString('en-IN', { hour: '2-digit', minute: '2-digit', hour12: true });
    }

    const handlecfmDelete = () => {
        setSlideED(prevState => !prevState);
        setDelete(prevState => !prevState);
    }

    const handleDelete = () => {
        deleteSolt(data.slotId).then(res => {
            if (res && res.status) {
                props.reloadData();
            }
        }).catch(err => {
            console.log("err === ", err);
        })
    }

    const handleNew = (status) => {
        setEdit(false);
        if (status) {
            setData(status);
            props.reloadData();
        }
    }

    return <div className="listAutoUL" key={data.slotId}>
        {slideED && <BtmEditDeletSlider slideED={slideED} handleSlideED={() => setSlideED(prevState => !prevState)} handleEdit={() => {setEdit(prevState => !prevState);setSlideED(prevState => !prevState);}} handleDelete={handlecfmDelete} />}
        {isDelete && <BtmDeleteSlide slideD={isDelete} handleCancel={() => setDelete(prevState => !prevState)} txt={l.conf_del} handleConfirm={handleDelete} />}
        {edit ?
            <CreateSlot data={data} scheduleId={data.scheduleId} handleClose={handleNew} scheduleData={props.scheduleData}/>
            : <Fragment>
                <div className="listAutoAvtr Md primarySL">
                    <span>{data.label && data.label.substring(0, 2).toUpperCase()}</span>
                </div>
                <div className="listAutoContent">
                    <span className="listTxtL">{getTime(data.from)} - {getTime(data.to)}</span>
                    <span className="listTxtM">{l.duration}: <small>{data.duration} mins</small></span>
                    <span className="listTxtM">{l.label}: <small>{data.label}</small></span>
                </div>
                <div className="listAutoAction" onClick={() => setSlideED(prevState => !prevState)}>
                    <div className="dotGroup dotsVrtcl topZero">
                        <div className="dot"></div>
                        <div className="dot"></div>
                        <div className="dot"></div>
                    </div>
                </div>
            </Fragment>}
    </div>

}

export default SlotListItem;